import "../../styles/Auth.scss"

import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { logEvent } from "firebase/analytics";
import { doc, setDoc } from "firebase/firestore";
import { auth, analytics, db } from "../../firebase-config";
import {setBackgroundImage, Toasts} from "../../helpers/helpers";
import { ReactComponent as Logo } from "../../assets/logo.svg"

const Register = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const navigate = useNavigate();

    const handleLogin = async () => {
        if (!email || !password || !confirmPassword) {
            Toasts.error("Please fill in all fields.");
            return;
        }

        if (password !== confirmPassword) {
            Toasts.error("Passwords don't match");
            return;
        }

        try {
            await createUserWithEmailAndPassword(auth, email, password).then(async cred => {
                const userId = cred.user.uid;
                const userDoc = doc(db, "users", userId);
                setDoc(userDoc, {
                    email: email,
                    createdAt: new Date(),
                    favorites: [],
                    watchlist: [],
                    history: []
                });
            });
            logEvent(analytics, 'sign_up');
            navigate("/");
        } catch (error: any) {
            console.error("Registration error:", error.message)
            Toasts.error(error.message);
        }
    }

    document.onkeydown = function (e) {
        if (e.key === "Enter") {
            handleLogin();
        }
    };

    setBackgroundImage('');

    return (
        <div className="login-container">
            <Logo className="logo" onClick={() => navigate("/")} />
            <div className="inputs">

                <input
                    type="email"
                    id="email"
                    className="login-input"
                    placeholder="Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}>
                </input>

                <input
                    type="password"
                    id="password"
                    className="login-input"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}>
                </input>

                <input
                    type="password"
                    id="confirm-password"
                    className="login-input"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}>
                </input>

                <button className="submit-button" onClick={handleLogin}>Register</button>
                <div className="signup-text">Already have an account? <Link to="/login">Log In</Link></div>
            </div>
        </div>
    )
}

export default Register;